<mat-form-field class="w-full">
  <input matInput readonly [(ngModel)]="nome" />
</mat-form-field>
